<template lang='pug'>
    .download-container(v-if="!bookMarksLoading")
        .searchVal-container1
            .searchVal-container
                img(src='@/assets/imgs/search@3x.png')
                input(v-model='searchVal', placeholder='搜索')
        .allKind-container
            .allKind-title 产品类别
            .allKind-items
                .item(
                    :class='{ active: activeKey === item.name }',
                    v-for='item in showKind',
                    :key='item.id',
                    @click='choose(item)'
                ) {{ item.name }}
                .more-button(v-show='!moreButtonVisible', @click='showMore') 更多
                .more-button(v-show='moreButtonVisible', @click='hideMore') 收起
        .list-container
            template(
                v-for='item in searchData',
            )
                InformationDownload.list(
                    :key='item.id',
                    :id="item.id"
                    :hId= "dataHierarchyId"
                    :name='item.pdfName',
                    :link='item.pdfLink',
                    type='shoucang'
                    v-if="item.status=='Enable'"
                )
</template>

<script>
    import {mapState} from 'vuex'
    import InformationDownload from './components/informationDownload'
    import {GetDataList} from "@/service/dataPool";
    import {isFullURI} from '@/utils/common'
    import { getDataHierarchies, getDataRows } from '@custouch/proxy-use'
    import { getCmsStr } from './levelTitle'
    export default {
        name: 'download',
        components: {
            InformationDownload
        },
        data() {
            return {
                searchVal: '',
                allKind: [],
                moreButtonVisible: false,
                data: [],
                activeKey: null,
                dataHierarchyId: ''
            }
        },
        watch: {},
        computed: {
            ...mapState(['bookMarks', 'memberInfo', 'bookMarksLoading']),

            showKind() {
                return this.moreButtonVisible ? this.allKind : this.allKind.slice(0, 4)
            },
            searchData() {
                let res
                if (!this.activeKey) {
                    res = Object.values(this.data).flat()
                } else {
                    res = this.data[this.activeKey]
                }
                const reg = new RegExp(this.searchVal, 'gi')
                return res.filter(val => {
                    if (reg.test(val.pdfName)) {
                        return val
                    }
                })

            }
        },
        methods: {
            showMore() {
                this.moreButtonVisible = true
            },
            hideMore() {
                this.moreButtonVisible = false
            },
            choose(item) {
                if (this.activeKey === item.name) {
                    this.activeKey = null
                    return
                }
                const key = Object.keys(this.data).find(key => key === item.name)
                if (key) {
                    this.activeKey = key
                }
            }
        },
        async created() {
            this.$root.$emit('action', {name: this.$route.name})
            const { module, template } = window.env.VITE_DATA
            const Hierarchies = await getDataHierarchies(module.download)
            let dataHierarchyId = Hierarchies[0] ? Hierarchies[0].id : ''
            this.dataHierarchyId = dataHierarchyId
            const { data } = await getDataRows({dataTemplateId:template.download, dataHierarchyId, index: 1, size: 999})
            const cms = getCmsStr({mId: this.$route.meta.mId,hId: dataHierarchyId})
            this.$root.$emit('pageview',{cms})
            data.forEach(val => {
                Object.assign(val, val.detail)
            })
            this.data = data.reduce((pre, cur) => {
                let t = {
                    title: cur.title,
                    pdfLink: cur.pdfLink,
                    pdfName: cur.pdfName,
                    status: cur.status,
                    id: cur.id
                }
                if (!pre[cur.title]) {
                    pre[cur.title] = [t]
                } else {
                    pre[cur.title].push(t)
                }
                return pre
            }, {})
            this.allKind = Object.keys(this.data).map((name, id) => ({name, id}))
        }
    }
</script>

<style scoped lang='less'>
    .download-container {
        display: flex;
        flex-direction: column;

        .searchVal-container1 {
            padding: 0rem 1rem 0rem 1rem;
        }

        .searchVal-container {
            display: flex;
            height: 1.6rem;
            background: #ffffff;
            border: 0.05rem solid #e3e3e3;
            border-radius: 0.2rem;
            align-items: center;
            margin-bottom: 1rem;

            img {
                width: 0.7rem;
                height: 0.7rem;
                display: block;
                margin-left: 0.55rem;
            }

            input {
                padding: 0;
                margin-left: 0.33rem;
                border: none;
                width: 100%;
            }
        }

        .list-container {
            padding-left: 1rem;
            padding-right: 1rem;
            padding-bottom: 1.7rem;
            height: 100%;
            overflow: auto;

            .list {
                margin-bottom: 0.6rem;
            }
        }
    }

    .allKind-container {
        .allKind-title {
            color: #07448a;
            font-size: 0.6rem;
            line-height: 0.85rem;
            margin-bottom: 0.6rem;
            margin-left: 1rem;
            font-weight: 700;
        }

        .allKind-items {
            display: flex;
            flex-wrap: wrap;
            font-size: 0.55rem;
            justify-content: flex-start;
            padding: 0rem 0.6rem 0.8rem 0.8rem;

            .more-button {
                display: flex;
                align-items: center;
                justify-content: center;
                background: #f3f3f3;
                height: 1.2rem;
                width: 2.1rem;
                border-radius: 0.6rem;
                color: #219cdc;
                margin-left: 0.2rem;
                margin-right: 0.2rem;
            }

            .item {
                margin-bottom: 0.6rem;
                font-size: 0.55rem;
                color: #222222;
                text-align: center;
                height: 1.2rem;
                line-height: 1.2rem;
                padding-left: 0.45rem;
                padding-right: 0.45rem;
                border-radius: 0.6rem;
                margin-left: 0.2rem;
                margin-right: 0.2rem;
                background: #f3f3f3;
                color: #000;
            }

            .active {
                background: #07448a;
                color: #fff;
            }
        }
    }

    .allKind-moreButtonVisible {
        background: #219cdc;
    }
</style>
